/** @format */
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-cart-container',
    templateUrl: './cart-container.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CartContainerComponent {
    /**
     * Translation key of the page title.
     */
    @Input({ required: true }) pageTitle: string;
}
